document.addEventListener("DOMContentLoaded", function () {

    let subContainer = document.querySelector(".sub-container");
    if (subContainer) {
        let mobileSwitch = document.querySelector(".mobile-switch");
        let subList = document.querySelector(".sub-list");
        mobileSwitch.addEventListener("click", function () {
            mobileSwitch.classList.toggle("active");
            subList.classList.toggle("shown");
        });
    }

});